
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiObjectFlotsam as ObiObjectFlotsamElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-object-flotsam.js';
 
 
 

 
 export const ObiObjectFlotsam = createComponent({
   react: React,
   tagName: 'obi-object-flotsam',
   elementClass: ObiObjectFlotsamElement,
   events: {
     
   }
  });
 
 